const BASE_URL = 'https://wellvita-api.netlify.app/.netlify/functions';

export async function applyRedeemGiftCard(payload) {
    try {
        const response = await fetch(`${BASE_URL}/redeemGiftCardInCheckout?store=${Theme.settings.store_handle}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || data);
        }
        return data;
    } catch (error) {
        console.error('❌ Apply redeem gift card failed:', error);
        throw error;
    }
}